/**
 * <s-card-view> — Product / Model toggle in the collection toolbar.
 * Sets html[data-card-view] to "product" or "model" (cards' on-model photos fade in via CSS)
 * and remembers the choice in localStorage. Child buttons carry data-view="product|model".
 */
const STORAGE_KEY = 'tatlim-card-view';

class SCardView extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    this.addEventListener('click', (event) => this.#onClick(event), { signal: this.#ac.signal });
    this.#sync(document.documentElement.dataset.cardView || 'product');
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #onClick(event) {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const button = target.closest('button[data-view]');
    if (!(button instanceof HTMLButtonElement) || !this.contains(button)) return;
    event.preventDefault();
    const view = button.dataset.view === 'model' ? 'model' : 'product';
    document.documentElement.dataset.cardView = view;
    try {
      localStorage.setItem(STORAGE_KEY, view);
    } catch {
      /* storage unavailable: the choice just won't persist */
    }
    this.#sync(view);
  }

  #sync(view) {
    for (const button of this.querySelectorAll('button[data-view]')) {
      button.setAttribute('aria-pressed', String(button.dataset.view === view));
    }
  }
}

customElements.define('s-card-view', SCardView);
